<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="أين-يمضي">
<h1>1<span dir="rtl">-</span> <span dir="rtl">أين يمضي</span></h1>
<p><span dir="rtl">أين باقي الوقت؟</span></p>
<p><span dir="rtl">مَن الذي يسألُ؟</span></p>
<p><span dir="rtl">إنَّه الوقتُ</span></p>
<p><span dir="rtl">على الأرضِ يقفُ متردِّدًا.. لماذا؟</span></p>
<p><span dir="rtl">ارتقَى إلى السماءِ</span></p>
<p><span dir="rtl">لماذا؟</span></p>
<p><span dir="rtl">مَن الذي أزعجَه؟</span></p>
<p><span dir="rtl">لقد شربَ كأسًا بينَنا</span></p>
<p><span dir="rtl">أين الوقتُ؟</span></p>
<p><span dir="rtl">يجلسُ على الغصنِ الأخضرِ</span></p>
<p><span dir="rtl">ما الذي ينتظرُ؟</span></p>
<p><span dir="rtl">العصافيرُ رحلت مِن الأوراقِ الصفراءِ</span></p>
<p><span dir="rtl">أمسكَت بالظلِّ الباقي مِن الأمسِ</span></p>
<p><span dir="rtl">وراحَت تسعى</span></p>
<p><span dir="rtl">تبحثُ عن وقتٍ جديد</span></p>
<p><span dir="rtl">أين مضَى الوقتُ؟</span></p>
<p><span dir="rtl">أخذَته الفراشةُ الملوَّنةُ</span></p>
<p><span dir="rtl">إلى أين؟</span></p>
<p><span dir="rtl">احتضنَت منه دقائقَ وبعضَ الثَّواني</span></p>
<p><span dir="rtl">لقد رأتِ الحُلمَ الذي كان</span></p>
<p><span dir="rtl">تراكمَت فوقَه أجندةٌ أخرى</span></p>
<p><span dir="rtl">بلا قيدٍ.. بلا أملٍ على تلك الصفحةِ الأخرى</span></p>
<p><span dir="rtl">ذلك الكتابُ الدَّفترُ القديمُ</span></p>
<p><span dir="rtl">الذي يحتضنُ الذكرى التي كانت</span></p>
<p><span dir="rtl">ذَيَّلَتِ الهامشَ بالوقتِ</span></p>
<p><span dir="rtl">رحلَتِ الفراشاتُ</span></p>
<p><span dir="rtl">تبحثُ عن وقتٍ جديدٍ</span></p>
<p><span dir="rtl">أين الوقتُ؟</span></p>
<p><span dir="rtl">يسألُ ويجيبُ</span></p>
<p><span dir="rtl">فقد أعطَى الكثيرَ</span></p>
<p><span dir="rtl">ومنحَ الكثيرَ مِن الوقتِ</span></p>
<p><span dir="rtl">انصرفَت عنه رائحةُ الصبرِ</span></p>
<p><span dir="rtl">تعرَّجَت داخلَه الثَّواني التي كانت</span></p>
<p><span dir="rtl">اعتصرَ الوقتُ نفسَه في ذلك الكأسِ</span></p>
<p><span dir="rtl">وضعَ سجلَّه على الطاولةِ الأخرى</span></p>
<p><span dir="rtl">كانَ الوقتُ أُنسًا</span></p>
<p><span dir="rtl">كانَ الوقتُ أمسِ</span></p>
<p><span dir="rtl">وهنا هو ذاكَ الوقتُ</span></p>
<p><span dir="rtl">يحملُ الكثيرَ</span></p>
<p><span dir="rtl">الجدولَ والعبيرَ</span></p>
<p><span dir="rtl">العصفورَ والأملَ</span></p>
<p><span dir="rtl">فهل الأرضُ هي غيرُ الأرضِ؟</span></p>
<p><span dir="rtl">واقفًا عليها</span></p>
<p><span dir="rtl">كانَ له ذكرى</span></p>
<p><span dir="rtl">رائحةٌ طيِّبةٌ زكيَّة</span></p>
<p><span dir="rtl">ترجَّلَ اليومَ عنه ذلك الأُنسُ</span></p>
<p><span dir="rtl">والوقتُ غيرُ الوقتِ</span></p>
<p><span dir="rtl">أحمد كريم عز الدين.. سوريا</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?615d63d5